import { render } from "./AccessView.vue?vue&type=template&id=7e9e165a&scoped=true"
import script from "./AccessView.vue?vue&type=script&lang=js"
export * from "./AccessView.vue?vue&type=script&lang=js"

import "./AccessView.vue?vue&type=style&index=0&id=7e9e165a&lang=scss&scoped=true"

import exportComponent from "/home/douglas/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e9e165a"]])

export default __exports__